<section
  class="auth-flow auth-flow--hero"
  [class.auth-flow--desbloquear]="isDesbloquear"
  [class.auth-flow--origen-micro]="authOrigen === 'micro'"
  [class.auth-flow--origen-if]="authOrigen === 'if'"
  [attr.id]="isRecordar ? 'recordar-contrasena' : isDesbloquear ? 'desbloquear-usuario' : 'activar-usuario'"
>
  <app-header-public variant="v2" [showAuthButtons]="true" [showRegisterButton]="false"></app-header-public>

  <div class="auth-flow__vigilado" aria-hidden="true">
    <img class="auth-flow__vigilado-img" src="assets/img/Home/hero/Ico_super.svg" alt="" />
  </div>

  <main class="auth-flow__main">
    <div class="auth-flow__hero">
      <div
        class="auth-flow__bg"
        aria-hidden="true"
        [style.background-image]="'url(' + bgDesktop + ')'"
      ></div>

      <div class="auth-flow__visual-mobile" aria-hidden="true">
        <span class="auth-flow__bubble auth-flow__bubble--tl-lg"></span>
        <span class="auth-flow__bubble auth-flow__bubble--tl-sm"></span>
        <img class="auth-flow__visual-mobile-img" [src]="bgMobile" alt="" />
      </div>

      <h1 class="auth-flow__hero-title">{{ titulo }}</h1>

      <span class="auth-flow__bubble auth-flow__bubble--br-lg auth-flow__bubble--desktop" aria-hidden="true"></span>
      <span class="auth-flow__bubble auth-flow__bubble--br-sm auth-flow__bubble--desktop" aria-hidden="true"></span>

      <div class="auth-flow__panel">
        <span class="auth-flow__bubble auth-flow__bubble--tl-lg auth-flow__bubble--desktop" aria-hidden="true"></span>
        <span class="auth-flow__bubble auth-flow__bubble--tl-sm auth-flow__bubble--desktop" aria-hidden="true"></span>

        <h2 class="auth-flow__title auth-flow__title--panel">{{ titulo }}</h2>

        <form class="auth-flow__form" [formGroup]="validarForm" (ngSubmit)="validateForm()" novalidate>
          @if (isDesbloquear) {
          <div class="auth-flow__field auth-flow__field--center">
            <p class="auth-flow__label auth-flow__label--block">¿Cómo deseas validar tu identidad?*</p>
            <div class="auth-flow__radios" role="radiogroup" aria-label="Opción de validación">
              <label class="auth-flow__radio">
                <input class="auth-flow__radio-input" type="radio" formControlName="opcion" [value]="1"
                  (click)="validarOpcion(1)" (keydown.enter)="validarOpcion(1)" />
                <span>Correo electrónico</span>
              </label>
              <label class="auth-flow__radio">
                <input class="auth-flow__radio-input" type="radio" formControlName="opcion" [value]="2"
                  (click)="validarOpcion(2)" (keydown.enter)="validarOpcion(2)" />
                <span>Número de documento</span>
              </label>
            </div>
          </div>
          }

          @if (validarForm.get('opcion')?.value == 1 || !isDesbloquear) {
          <div class="auth-flow__field" [class.auth-flow__field--invalid]="validateField('correoElectronico')">
            <label class="auth-flow__label" for="correoElectronico">
              Correo electrónico*
            </label>
            <input id="correoElectronico" type="email" class="auth-flow__control" formControlName="correoElectronico"
              maxlength="50" autocomplete="email" [class.is-invalid]="validateField('correoElectronico')"
              (input)="onEmailInput($event)" />
            <div class="auth-flow__error">El correo electrónico no tiene un formato válido.</div>
          </div>
          }

          @if (isDesbloquear && validarForm.get('opcion')?.value == 2) {
          <p class="auth-flow__hint">
            Si eres persona natural o Aliado Financiero, digita el número de documento con el cual te registraste en el
            canal. Si eres persona jurídica, debes digitar el número de documento de la persona de contacto.
          </p>

          <div class="auth-flow__row">
            <div class="auth-flow__field" [class.auth-flow__field--invalid]="validateField('idTipoDocumento')">
              <label class="auth-flow__label" for="idTipoDocumento">Tipo de documento*</label>
              <select id="idTipoDocumento" class="auth-flow__control" formControlName="idTipoDocumento"
                [class.is-invalid]="validateField('idTipoDocumento')" (change)="validarSelect()">
                <option value="">Seleccione una opción</option>
                @for (documento of documentos; track documento.idTipoDocIdentidad) {
                <option [value]="documento.idTipoDocIdentidad">{{ documento.nombre }}</option>
                }
              </select>
              <div class="auth-flow__error">Campo obligatorio</div>
            </div>

            <div class="auth-flow__field" [class.auth-flow__field--invalid]="validateField('numeroDocumento')">
              <label class="auth-flow__label" for="numeroDocumento">Número de documento*</label>
              <input id="numeroDocumento" type="text" class="auth-flow__control" formControlName="numeroDocumento"
                maxlength="15" autocomplete="off"
                [class.is-invalid]="validateField('numeroDocumento')"
                appNumeroDocumentoPorTipo
                [tipos]="documentos"
                idTipoDocControlName="idTipoDocumento" />
              @if (validarForm.get('numeroDocumento')?.hasError('documentPattern')) {
              <div class="auth-flow__error">{{ mensajeErrorNumeroDocumento }}</div>
              } @else {
              <div class="auth-flow__error">Campo obligatorio</div>
              }
            </div>
          </div>
          }

          <div class="auth-flow__actions">
            <button type="submit" class="auth-flow__btn auth-flow__btn--primary" [disabled]="validarForm.invalid">
              Buscar cliente
            </button>
            <button type="button" class="auth-flow__btn auth-flow__btn--secondary" (click)="back()">
              Volver
            </button>
          </div>
        </form>
      </div>
    </div>
  </main>

  <app-home-site-footer></app-home-site-footer>
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
</section>
